import React, { useEffect, useState } from 'react';
import DailyVotingChart from '../../../components/charts/dailyVotingBarchart';
import { baseurl } from '../../../components/lib/settings';
import { Select, Row, Col, Card, Typography, Alert, Spin } from 'antd';
import "./dailyvotings.css";

const { Option } = Select;
const { Title } = Typography;

const DailyVotingList = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState(String(new Date().getMonth() + 1).padStart(2, '0'));
    const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()));
    const [permissions, setPermissions] = useState([]);
    const [delegationList, setDelegationList] = useState([]);
    const [selectedDelegation, setSelectedDelegation] = useState(null);

    const convertEdition = localStorage.getItem('selectedEdition')
    const edt = convertEdition ? JSON.parse(convertEdition) : null;
    const selectedEditionId = edt

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    const years = Array.from({ length: currentYear - 2023 }, (_, i) => (2024 + i).toString());

    const months = [
        { label: 'Janeiro', value: '01' },
        { label: 'Fevereiro', value: '02' },
        { label: 'Março', value: '03' },
        { label: 'Abril', value: '04' },
        { label: 'Maio', value: '05' },
        { label: 'Junho', value: '06' },
        { label: 'Julho', value: '07' },
        { label: 'Agosto', value: '08' },
        { label: 'Setembro', value: '09' },
        { label: 'Outubro', value: '10' },
        { label: 'Novembro', value: '11' },
        { label: 'Dezembro', value: '12' }
    ].filter(month => {
        if (selectedYear === currentYear.toString()) {
            return month.value <= String(currentMonth).padStart(2, '0');
        }
        return true;
    }).filter(month => selectedYear >= '2024' || month.value >= '06');

    const fetchData = () => {
        setLoading(true);
        setError(null);

        baseurl.post("v3/monthly-votings-by-day/", { selectedDelegation, selectedMonth, selectedYear, selectedEditionId })
            .then((response) => {
                if (response.data && response.data.daily_votes && response.data.daily_votes.length > 0) {
                    setData(response.data);
                } else {
                    setData(null);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                setError(error);
                setLoading(false);
            });
    };

    useEffect(() => {
        // Buscar lista de delegações e permissões apenas uma vez
        baseurl.get('v3/get_delegation_list/')
            .then((resp) => {
                setDelegationList(resp.data);
            }).catch((error) => {
                console.error(error);
            });

        baseurl.get('v1/check_userpermissions/')
            .then((resp) => {
                setPermissions(resp.data);
            }).catch((error) => {
                console.error(error);
            });

        // Buscar dados imediatamente
        fetchData();

        // Configurar intervalo para atualização automática (30 segundos)
        const intervalId = setInterval(fetchData, 120000);

        // Limpar intervalo ao desmontar o componente
        return () => clearInterval(intervalId);
    }, [selectedDelegation, selectedMonth, selectedYear]);

    if (error) {
        return <Alert message="Erro ao carregar dados" description={error.message} type="error" showIcon />;
    }

    const isAdmin = permissions.some(
        (perm) => perm.finance_administrator || perm.system_administrator
    );

    return (
        <div style={{ padding: 0 }}>
            <Card 
                bordered={false} 
                style={{ borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", marginBottom: "24px" }}
                bodyStyle={{ padding: "15px" }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '24px' }}>
                    <div>
                        <Title level={4} style={{ margin: 0, color: "#1f2937", fontWeight: 600 }}>Análise de Votos Diários</Title>
                        <Typography.Text type="secondary" style={{ fontSize: "14px" }}>Filtre e analise o volume de votação por delegação e período.</Typography.Text>
                    </div>
                </div>

                <Row gutter={[16, 16]}>
                    {isAdmin && (
                        <Col xs={24} sm={8}>
                            <Typography.Text strong style={{ display: 'block', marginBottom: '8px', color: '#4b5563' }}>Delegação</Typography.Text>
                            <Select
                                placeholder="Todas as delegações"
                                style={{ width: '100%' }}
                                size="large"
                                onChange={(value) => setSelectedDelegation(value)}
                                allowClear
                            >
                                {delegationList.map((delegation) => (
                                    <Option key={delegation.id} value={delegation.id}>
                                        {delegation.description}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                    )}
                    <Col xs={12} sm={isAdmin ? 8 : 12}>
                        <Typography.Text strong style={{ display: 'block', marginBottom: '8px', color: '#4b5563' }}>Ano</Typography.Text>
                        <Select
                            value={selectedYear}
                            onChange={(value) => setSelectedYear(value)}
                            style={{ width: '100%' }}
                            size="large"
                        >
                            {years.map((year) => (
                                <Option key={year} value={year}>{year}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={12} sm={isAdmin ? 8 : 12}>
                        <Typography.Text strong style={{ display: 'block', marginBottom: '8px', color: '#4b5563' }}>Mês</Typography.Text>
                        <Select
                            value={selectedMonth}
                            onChange={(value) => setSelectedMonth(value)}
                            style={{ width: '100%' }}
                            size="large"
                        >
                            {months.map((month) => (
                                <Option key={month.value} value={month.value}>{month.label}</Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </Card>
            
            <Card 
                bordered={false} 
                style={{ borderRadius: "16px", boxShadow: "0 4px 12px rgba(0,0,0,0.05)", minHeight: "400px" }}
                bodyStyle={{ padding: "24px" }}
            >
                {loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
                        <Spin size="large" />
                    </div>
                ) : data ? (
                    <DailyVotingChart data={data} />
                ) : (
                    <Alert 
                        message="Nenhum dado disponível" 
                        description="Não foram encontrados registos de votos para o período selecionado." 
                        type="info" 
                        showIcon 
                        style={{ borderRadius: "12px", border: "none", background: "#eff6ff", color: "#1e3a8a" }}
                    />
                )}
            </Card>
        </div>
    );
};

export default DailyVotingList;